import { z } from 'zod';

export const feedsConsumeResponseValidator = z.array(z.object({}));

export type FeedsConsumeResponse = z.output<
    typeof feedsConsumeResponseValidator
>;
